<template>
  <div class="">
    <!-- <div class="">
      {{stage}}
    </div> -->
    <!-- <keep-alive>
      <div class="fixed top-0 left-0 z-50 bg-blue text-white p-4" style="z-index:9999">
        {{count}}
      </div>
    </keep-alive> -->
    <keep-alive>
      <Jewellery2 />
    </keep-alive>
  </div>
</template>

<script>
// import {captions} from '@/common/content.js'
import Jewellery2 from '@/components/Jewellery2.vue'
// @ is an alias to /src
export default {
  name: 'Home',
  components: { Jewellery2 },
  data () {
    return {
      text: '',
      count: 0
    }
  },
  mounted () {
    setInterval(()=>{
      this.count++
    }, 1000)
  },
  computed: {
    stage () {
      return this.$store.state.stage
    }
  }
}
</script>

<style lang="scss" scoped>
.view {

}
</style>
